export default {
  /* TEXT */
  'text-primary': 'var(--text-primary)',
  'text-secondary': 'var(--text-secondary)',
  'text-tertiary': 'var(--text-tertiary)',
  'chip-text': 'var(--chip-text)',
  'input-text-placeholder': 'var(--input-text-placeholder)',
  'text-positive': 'var(--text-positive)',
  'text-warning': 'var(--text-warning)',
  'text-negative': 'var(--text-negative)',
  'tab-text-accent': 'var(--tab-text-accent)',
  'action-text': 'var(--action-text)',
  'action-text-default': 'var(--action-text-default)',
  'button-text': 'var(--button-text)',
  'button-text-inactive': 'var(--button-text-inactive)',

  'scroll-background-default': 'var(--scroll-background-default)',

  /* ICON */
  'icon-accent': 'var(--icon-accent)',
  'icon-accent-default': 'var(--icon-accent-default)',
  'tab-icon-active': 'var(--tab-icon-active)',
  'tab-icon-inactive': 'var(--tab-icon-inactive)',
  'icon-hover': 'var(--icon-hover)',
  'icon-active': 'var(--icon-active)',
  'icon-default': 'var(--icon-default)',
  'chip-icon': 'var(--chip-icon)',
  'icon-button': 'var(--icon-button)',
  'icon-alert': 'var(--icon-alert)',
  'icon-positive': 'var(--icon-positive)',
  'icon-warning': 'var(--icon-warning)',
  'icon-negative': 'var(--icon-negative)',
  'icon-blue-line': 'var(--icon-blue-line)',

  /* BUTTON */
  /* primary */
  'primary-button-background-default': 'var(--primary-button-background-default)',
  'primary-button-background-hover': 'var(--primary-button-background-hover)',
  'primary-button-background-active': 'var(--primary-button-background-active)',
  'primary-button-background-inactive': 'var(--primary-button-background-inactive)',
  /* secondary */
  'secondary-button-background': 'var(--secondary-button-background)',
  'secondary-button-background-hover': 'var(--secondary-button-background-hover)',
  'secondary-button-background-active': 'var(--secondary-button-background-active)',
  /* secondary-positive */
  'secondary-positive-button-background': 'var(--secondary-positive-button-background)',
  'secondary-positive-button-background-hover': 'var(--secondary-positive-button-background-hover)',
  'secondary-positive-button-background-active': 'var(--secondary-positive-button-background-active)',
  /* secondary-negative */
  'secondary-negative-button-background': 'var(--secondary-negative-button-background)',
  'secondary-negative-button-background-hover': 'var(--secondary-negative-button-background-hover)',
  'secondary-negative-button-background-active': 'var(--secondary-negative-button-background-active)',

  'white-button-background-default': 'var(--white-button-background-default)',
  'white-button-background-hover': 'var(--white-button-background-hover)',
  'white-button-background-active': 'var(--white-button-background-active)',
  'white-button-background-disabled': 'var(--white-button-background-disabled)',

  /* BORDER */
  'token-container-border': 'var(--token-container-border)',
  'filter-border': 'var(--filter-border)',
  'container-border': 'var(--container-border)',
  'active-container-border': 'var(--active-container-border)',
  'focus-container-border': 'var(--focus-container-border)',
  'filter-border-negative': 'var(--filter-border-negative)',
  'alert-border': 'var(--alert-border)',
  'alert-border-warning': 'var(--alert-border-warning)',
  'alert-border-negative': 'var(--alert-border-negative)',
  'token-border': 'var(--token-border)',
  'border-dark': 'var(--border-dark)',

  /* DIVIDER */
  divider: 'var(--divider)',

  /* BACKGROUND */
  'background-default': 'var(--background-default)',
  'switch-background-active': 'var(--switch-background-active)',
  'switch-background-inactive': 'var(--switch-background-inactive)',
  'top-nav-bar-background': 'var(--top-nav-bar-background)',
  'knob-background': 'var(--knob-background)',
  'block-background-default': 'var(--block-background-default)',
  'tab-background': 'var(--tab-background)',
  'left-navigation-menu-background': 'var(--left-navigation-menu-background)',
  'main-app-background': 'var(--main-app-background)',
  'token-container-background': 'var(--token-container-background)',
  'token-background': 'var(--token-background)',
  'input-background': 'var(--input-background)',
  'input-background-disabled': 'var(--input-background-disabled)',
  'action-background-hover': 'var(--action-background-hover)',
  'block-background-hover': 'var(--block-background-hover)',
  'block-background': 'var(--block-background)',
  'badge-background': 'var(--badge-background)',
  'badge-background-hover': 'var(--badge-background-hover)',
  'badge-red-background-default': 'var(--badge-red-background-default)',
  'badge-red-background': 'var(--badge-red-background)',
  'badge-dark-red-background': 'var(--badge-dark-red-background)',
  'badge-orange-background-default': 'var(--badge-orange-background-default)',
  'badge-green-background-default': 'var(--badge-green-background-default)',
  'badge-green-background': 'var(--badge-green-background)',
  'badge-dark-green-background': 'var(--badge-dark-green-background)',
  'extended-block-background': 'var(--extended-block-background)',
  'negative-action-background': 'var(--negative-action-background)',
  'dim-background': 'var(--dim-background)',
  'qr-valid-background': 'var(--qr-valid-background)',
  'positive-background': 'var(--positive-background)',
  'accent-background': 'var(--accent-background)',
  'row-background': 'var(--row-background)',
  hover: 'var(--hover)',
  'card-background': 'var(--card-background)',
  'alert-background': 'var(--alert-background)',
  'alert-background-warning': 'var(--alert-background-warning)',
  'alert-background-negative': 'var(--alert-background-negative)',
  'alert-background-positive': 'var(--alert-background-positive)',
  'label-background-green': 'var(--label-background-green)',
  'label-background-red': 'var(--label-background-red)',
  'label-background-gray': 'var(--label-background-gray)',
  'label-lightblue-default': 'var(--label-lightblue-default)',
  'label-purple-default': 'var(--label-purple-default)',
  'selected-background': 'var(--selected-background)',
  'black-background': 'var(--black-background)',
  'background-dark': 'var(--background-dark)',
  'background-item-hover': 'var(--background-item-hover)',
  'background-item-selected': 'var(--background-item-selected)',
  'background-suffix-hover': 'var(--background-suffix-hover)',

  /* CONVICTION SLIDER LABELS */
  'text-conviction-slider-text-01': 'rgba(70, 73, 246, 1)',
  'text-conviction-slider-text-1': 'rgba(70, 140, 246, 1)',
  'text-conviction-slider-text-2': 'rgba(53, 173, 211, 1)',
  'text-conviction-slider-text-3': 'rgba(1, 166, 62, 1)',
  'text-conviction-slider-text-4': 'rgba(181, 194, 24, 1)',
  'text-conviction-slider-text-5': 'rgba(245, 162, 0, 1)',
  'text-conviction-slider-text-6': 'rgba(246, 143, 7, 1)',
};
